module.exports = __webpack_public_path__ + "static/media/phone.6a959e8a.png";